import React from 'react';
import PropTypes from 'prop-types';

const YoutubeVideo = (props) => {
  const divStyle = {
    paddingBottom: '56.25%',
    position: 'relative',
    height: '0px',
    overflow: 'hidden',
    display: 'block',
  };

  const frameStyle = {
    position: 'absolute',
    top: '0px',
    left: '0px',
    width: '100%',
    height: '100%',
    display: 'block',
  };

  return (
    <span className="youtube-video">
      {props.title && <span className="youtube-video-heading">{props.title}</span>}

      <span className="youtube-video-holder" style={divStyle}>
        <iframe
          title={props.id}
          style={frameStyle}
          src={`https://www.youtube.com/embed/${props.id}`}
          frameBorder="0"
          allowFullScreen="allowfullscreen"
        />
      </span>
    </span>
  );
};

YoutubeVideo.propTypes = {
  title: PropTypes.string,
  id: PropTypes.string.isRequired,
};

export default YoutubeVideo;



// WEBPACK FOOTER //
// ./src/components/YoutubeVideo/YoutubeVideo.js